import dayjs from "dayjs";
import { array, date, mixed, object } from "yup";

export const FinallyAddDetailsValidation = object({
  prev_fy_end_date: date().required("From date is required"),
  date_till_import: date()
    .required("To date is required")
    .test(
      "is-after-prev-fy-end-date",
      "To date must be after the From date",
      function (value) {
        const { prev_fy_end_date } = this.parent;

        if (!value || !prev_fy_end_date) return true;

        return dayjs(value).isAfter(dayjs(prev_fy_end_date), "day");
      }
    ),
  coa_file: mixed().required("Chart of Accounts is required"),
  je_files: array().min(1, "Journal Entries is required"),
});
